import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/shared/services/alert.service';
import { AuthService } from '../auth.service';
import { LoginForm } from 'src/app/shared/models/auth/login-form.model';
import { Subscription } from 'rxjs';
import { HttpLoader } from 'src/app/shared/services/httploader.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit, OnDestroy {
  loader$;
  email: string;
  password: string;

  loginSubscription: Subscription;
  loginInLoading = false;
  redirectURL: string;
  constructor(
    private router: Router,
    private alertService: AlertService,
    private authService: AuthService,
    private loader: HttpLoader) { }

  ngOnInit() {
    this.loader$ = this.loader.loader$;
  }

  login() {
    const credentials = new LoginForm(this.email, this.password);
    this.loginInLoading = true;
    this.loginSubscription = this.authService.login(credentials).subscribe((result: any) => {
      this.loginInLoading = false;
      if (result && result.twoFactorStatus === 'required') {
        this.router.navigate(['/login/2fa']);
      } else if (result && result.twoFactorStatus === 'setup_required') {
        this.router.navigate(['/login/2fa/setup']);
      } else {
        this.router.navigate(['/']);
      }
    }, error => {
      this.loginInLoading = false;
      // this.alertService.setMessage(error.error.message);
    });
  }

  ngOnDestroy() {
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
  }
}
